// extracted by mini-css-extract-plugin
export default {"floating-cta":"FloatingCTA_floating-cta__Xqz3H"};